import { render, staticRenderFns } from "./QuestionnaireFlow.vue?vue&type=template&id=cc03c75e&scoped=true"
import script from "./QuestionnaireFlow.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionnaireFlow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./QuestionnaireFlow.vue?vue&type=style&index=0&id=cc03c75e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc03c75e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxButtonSecondary: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/button/Secondary.vue').default,IxButtonAction: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/button/Action.vue').default})
